import React, { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { signOutUser } from '../../core/reducers/user'

const LogoutComponent = memo(() => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(signOutUser())
    navigate('/login')
  }, [])

  return (<>Logging out...</>)
})

LogoutComponent.displayName = 'LogoutComponent'

export default LogoutComponent
